export default "__VITE_ASSET__TA44zwnj__"